export default __webpack_public_path__ + "static/media/tripad.f4694f56.svg";